/* Luminaire France V53: only consented GA4 wishlist events, no PII or Customer Match. */
(function(){
 'use strict';
 function consented(){
   try{
     var p=window.Shopify&&window.Shopify.customerPrivacy;
     return !!(p&&typeof p.analyticsProcessingAllowed==='function'&&p.analyticsProcessingAllowed()&&typeof p.marketingAllowed==='function'&&p.marketingAllowed());
   }catch(e){return false;}
 }
 window.addEventListener('lf:wishlist:change',function(event){
   var data=event.detail||{};
   if(data.active!==true||typeof data.handle!=='string'||!data.handle||!consented())return;
   if(typeof window.gtag!=='function')return;
   var item=data.handle.slice(0,160);
   try{
     window.gtag('event','add_to_wishlist',{
       send_to:'G-99NWEVMTM5',
       currency:'EUR',
       items:[{item_id:item,quantity:1}]
     });
   }catch(e){}
 });
})();